import { __module as r } from "../../../_virtual/isISBN.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(e = r.exports, "__esModule", {
  value: !0
}), e.default = function r(t) {
  var e,
    u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  if ((0, a.default)(t), !(u = String(u))) return r(t, 10) || r(t, 13);
  var o = t.replace(/[\s-]+/g, ""),
    l = 0;
  if ("10" === u) {
    if (!s.test(o)) return !1;
    for (e = 0; e < 9; e++) l += (e + 1) * o.charAt(e);
    if ("X" === o.charAt(9) ? l += 100 : l += 10 * o.charAt(9), l % 11 == 0) return !!o;
  } else if ("13" === u) {
    if (!f.test(o)) return !1;
    for (e = 0; e < 12; e++) l += i[e % 2] * o.charAt(e);
    if (o.charAt(12) - (10 - l % 10) % 10 == 0) return !!o;
  }
  return !1;
}, a = t && t.__esModule ? t : {
  default: t
}, s = /^(?:[0-9]{9}X|[0-9]{10})$/, f = /^(?:[0-9]{13})$/, i = [1, 3], r.exports = e.default, r.exports.default = e.default;
var e,
  a,
  s,
  f,
  i,
  u = r.exports;
export { u as i };